export * from './lib/shared-initialization.module'
export * from './lib/appLanguageInitializerFactory'
